import { Filterable } from "./mixins/Filterable";
import { SaveButton } from "../../components/SaveButton";
import { ScopedClass } from "./ScopedClass";

export class CRUDEntity extends ScopedClass {

    constructor() {
        Object.assign(CRUDEntity.prototype, Filterable);
        super();
    };

    create(successCallback=this.callbackCloseModal, errorCallback=this.callbackError){
        const formId = `create-${this.entityClass}`;
        const data = this.collectDataInForm(formId);
        const SaveBtn = new SaveButton(`#${formId}`);
        $.ajax({
            url: `${this.urlRoot}/create`,
            method: 'PUT',
            data: data,
            beforeSend: () => {
                SaveBtn.startLoading();
            },
            success: (response) => {
                SaveBtn.stopLoading().then(() => {
                    SaveBtn.showSuccess(formId)
                    .then(()=>successCallback(response))
                    .then(result => {
                        if(result) setTimeout(() => window.location.reload(), 500)
                    });
                })
            },
            error: (response) => {
                SaveBtn.stopLoading().then( () => {
                    SaveBtn.showError().then(() => {
                        errorCallback(response)
                    })
                })
            }
        })
    }
    read() {
        if (this.id) {
            let result;
            $.ajax({
                url: `${this.urlRoot}/${this.id}`,
                method: 'GET',
                async: false,
                success: (data) => {
                    result = data;
                }
            });
            return result;
        } else {
            return {};
        }
    }

    update(successCallback=this.callbackCloseModal, errorCallback=this.callbackError) {
        const formId = `edit-${this.entityClass}`;
        const data = this.collectDataInForm(formId);
        const SaveBtn = new SaveButton(`#${formId}`);
        $.ajax({
            url: `${this.urlRoot}/${this.id}/update`,
            data: data,
            method: 'POST',
            beforeSend: () => {
                SaveBtn.startLoading();
            },
            success: (response) => {
                SaveBtn.stopLoading(true).then(() => {
                    SaveBtn.showSuccess(formId)
                    .then(()=>successCallback(response))
                    .then(()=>document.dispatchEvent(new CustomEvent('entity_updated',{ detail: {entity:this}})))
                });

                const isCockpitPath = () => {
                    const path = window.location.pathname;
                    const match = path.match(/^\/cockpit\/[^\/]+$/);
                    return !!match;
                }

                if (isCockpitPath() && this.urlRoot === '/ticket-management/incident') {
                    const userId = response.entity.user_id;
                    const $element = $(`a[id="${userId}"], a[data-id="${userId}"]`);

                    if ($element.length) {
                        $element.click();
                    }
                }
            },
            error: (response) => {
                errorCallback(response);
                SaveBtn.stopLoading().then( () => {
                    SaveBtn.showError().then()
                })
            }
        });
    }

    delete() {
        const url = `${this.urlRoot}/${this.id}/delete`;
        return fetch(url, { method: 'POST' });
    }

    reloadCallback() {
        location.reload(true);
    }

    callbackCloseModal(reload=true) {
        $('.modal').modal('hide');
        return reload
    }

    callbackCloseWindow() {
        alert('success');
        window.close();
        return true
    }

    callbackError(response){
        if (response.responseJSON.errors) {
            $('.component-data-save .error-message').addClass('text-danger').text('Details:')
            let errors_arr = Object.values(response.responseJSON.errors);
            console.log(errors_arr);
            errors_arr.forEach(element => {
                if (Array.isArray(element)) {
                    element.forEach(error => {
                        $('.component-data-save .error-message').append('<br>'+error);
                    });
                } else {
                    $('.component-data-save .error-message').append('<br>'+element);
                }
            });
        }
    }

    getClass(){
        return this.constructor;
    }
}
